import {map} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {fiatAccountTotalAssets$} from './assets-fiat-account';
import {Assets} from '@/types';

export interface UAssetsFiatAccountData {
  type: 'fiat-account-assets';
  data: {
    assets: Assets;
  };
}

export function subscribeFiatTotalAssets() {
  fiatAccountTotalAssets$
    .pipe(map((assets): UAssetsFiatAccountData => ({type: 'fiat-account-assets', data: {assets}})))
    .subscribe((msg) => toUiMsg$.next(msg));
}
